import { Platform, StyleSheet } from 'react-native'

import { theme } from '../../../../theme'

export const webCookieConsentBannerStyles = StyleSheet.create({
  container: {
    position: 'absolute',
    bottom: 16,
    left: 16,
    right: 16,
    borderRadius: 14,
    borderWidth: 1,
    borderColor: theme.gray[700],
    backgroundColor: '#121827',
    paddingHorizontal: 14,
    paddingTop: 12,
    paddingBottom: 10,
    zIndex: 1000,
    ...(Platform.OS === 'web'
      ? ({
          maxWidth: 580,
          alignSelf: 'center',
        } as const)
      : {}),
  },
  title: {
    color: theme.white,
    fontSize: 14,
    fontWeight: '700',
    marginBottom: 4,
  },
  message: {
    color: theme.gray[300],
    fontSize: 12,
    lineHeight: 18,
  },
  link: {
    color: '#A78BFA',
    fontWeight: '600',
  },
  actionsRow: {
    marginTop: 10,
    flexDirection: 'row',
    justifyContent: 'flex-end',
  },
  actionButton: {
    minHeight: 36,
    borderRadius: 10,
    paddingHorizontal: 12,
    alignItems: 'center',
    justifyContent: 'center',
    marginLeft: 8,
    borderWidth: 1,
    borderColor: theme.gray[600],
    backgroundColor: '#1A2235',
  },
  actionButtonPrimary: {
    borderColor: '#8B5CF6',
    backgroundColor: '#8B5CF6',
  },
  actionButtonPressed: {
    opacity: 0.85,
  },
  actionButtonText: {
    color: theme.white,
    fontSize: 12,
    fontWeight: '600',
  },
})

